import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M3 4C3 3.44772 3.44772 3 4 3H10C10.2761 3 10.5 2.77614 10.5 2.5C10.5 2.22386 10.2761 2 10 2H4C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V7.5C14 7.22386 13.7761 7 13.5 7C13.2239 7 13 7.22386 13 7.5V12C13 12.5523 12.5523 13 12 13H4C3.44772 13 3 12.5523 3 12V4ZM13.8536 3.85355C14.0488 3.65829 14.0488 3.34171 13.8536 3.14645C13.6583 2.95118 13.3417 2.95118 13.1464 3.14645L7 9.29289L5.35355 7.64645C5.15829 7.45118 4.84171 7.45118 4.64645 7.64645C4.45118 7.84171 4.45118 8.15829 4.64645 8.35355L6.57574 10.2828C6.81005 10.5172 7.18995 10.5172 7.42426 10.2828L13.8536 3.85355Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
